import {hasSeatingPlan, isAvailableDonationTicket, isRegistrationClosedVisible} from '@wix/wix-events-commons-statics'
import {State} from '../types'

export const ticketDescriptionExpanded = (state: State, ticketDefId: string) =>
  Boolean(state.ticketsPicker.tickets?.[ticketDefId]?.expandedDescription)

export const isDonationInputVisible = (state: State, ticket: wix.events.ticketing.TicketDefinition) =>
  isAvailableDonationTicket(ticket) && !isRegistrationClosedVisible(state.event) && !hasSeatingPlan(state.event)
